import { render, staticRenderFns } from "./RegisterMember.vue?vue&type=template&id=0e8afb1c&scoped=true"
import script from "./RegisterMember.vue?vue&type=script&lang=js"
export * from "./RegisterMember.vue?vue&type=script&lang=js"
import style0 from "./RegisterMember.vue?vue&type=style&index=0&id=0e8afb1c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8afb1c",
  null
  
)

export default component.exports